import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/1.png'


const _withScopeId = n => (_pushScopeId("data-v-51d115ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "zs_list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "list_title" }, "政府采购从业人员培训证书查询", -1))
const _hoisted_3 = { class: "zs_center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "zs_des" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "姓名", -1))
const _hoisted_8 = { class: "zs_des" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "性别", -1))
const _hoisted_10 = { class: "zs_des zs_long" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "身份证号", -1))
const _hoisted_12 = { class: "zs_des zs_long" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "工作单位", -1))
const _hoisted_14 = { class: "zs_des" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "证书编号", -1))
const _hoisted_16 = { class: "zs_des" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "发证单位", -1))
const _hoisted_18 = { class: "zs_des" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "发证日期", -1))
const _hoisted_20 = { class: "zs_des" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "有效期至", -1))
const _hoisted_22 = { style: {"overflow":"hidden"} }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("查看证书")
const _hoisted_24 = {
  key: 1,
  class: "overdue"
}
const _hoisted_25 = { class: "title" }
const _hoisted_26 = { class: "zs_des" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "姓名", -1))
const _hoisted_28 = { class: "zs_des" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "性别", -1))
const _hoisted_30 = { class: "zs_des zs_long" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "身份证号", -1))
const _hoisted_32 = { class: "zs_des zs_long" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "工作单位", -1))
const _hoisted_34 = { class: "zs_des" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "证书编号", -1))
const _hoisted_36 = { class: "zs_des" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "发证单位", -1))
const _hoisted_38 = { class: "zs_des" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "发证日期", -1))
const _hoisted_40 = { class: "zs_des" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "有效期至", -1))
const _hoisted_42 = { style: {"overflow":"hidden"} }
const _hoisted_43 = /*#__PURE__*/_createTextVNode("查看证书")
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "over_pic"
}, null, -1))

import { onMounted, reactive } from "vue";
import * as zsApi from "@/api/zs";
import { useRoute } from "vue-router";
import router from "@/router";
import { ElMessageBox } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

let zsData = reactive({
  data: [],
});

/**
 * @description: 根据专家id获取证书信息
 * @param {
 *  pageNum：分页器页码
 * }
 * @return {*}
 */
const asyncCodeZsData = async (pageNum) => {
  try {
    const params = {
      code: route.query.code,
      pageNum: pageNum,
      pageSize: 5,
    };
    const res = await zsApi.queryByCode(params);
    if (res.resCode == 200) {
      zsData.data = res.resData.list || [];
      if (zsData.data.length !== 0) {
        zsData.data.forEach((item) => {
          let date = item.zsEndTime.substring(0, 19);
          date = date.replace(/-/g, "/");
          let timestamp = new Date(date).getTime();
          let nowTimestamp = new Date().getTime();
          if (nowTimestamp > timestamp) {
            item.isOverdue = 1;
          } else {
            item.isOverdue = 0;
          }
        });
      } else {
        ElMessageBox.alert("该编码下没有证书信息，请核对后重试。", "提示", {
          confirmButtonText: "知道了",
        });
      }
    }
  } catch (e) {
    ElMessageBox.alert("证书查询失败，请稍后重试。", "提示", {
      confirmButtonText: "知道了",
    });
  }
};

/**
 * @description: 进入证书详情
 * @param {
 *  data: 证书数据
 * }
 * @return {*}
 */
const goZsInfo = (data) => {
  console.log(data);
  if (data.isNew == 1) {
    router.push({
      path: "/zs_center",
    });
    localStorage.setItem("zsData", JSON.stringify(data));
  } else {
    router.push({
      path: "/zs_center_old",
    });
    localStorage.setItem("zsData", JSON.stringify(data));
  }
};

onMounted(() => {
  if (route.query.code) {
    asyncCodeZsData(1);
  } else {
    router.push({
      path: "/",
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(zsData).data, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (item.isOverdue == 0)
              ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(item.yxbName), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("p", null, _toDisplayString(item.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("p", null, _toDisplayString(item.sex == 1 ? "男" : "女"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("p", null, _toDisplayString(item.ident), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("p", null, _toDisplayString(item.company), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("p", null, _toDisplayString(item.zsCode), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("p", null, _toDisplayString(item.issueUnit), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("p", null, _toDisplayString(item.zsStartTime), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("p", null, _toDisplayString(item.zsEndTime), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      class: "check_zs",
                      onClick: ($event: any) => (goZsInfo(item))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_23
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("li", _hoisted_24, [
                  _createElementVNode("p", _hoisted_25, _toDisplayString(item.zsName), 1),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("p", null, _toDisplayString(item.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("p", null, _toDisplayString(item.sex == 1 ? "男" : "女"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("p", null, _toDisplayString(item.ident), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("p", null, _toDisplayString(item.company), 1)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("p", null, _toDisplayString(item.zsCode), 1)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("p", null, _toDisplayString(item.issueUnit), 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("p", null, _toDisplayString(item.zsStartTime), 1)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("p", null, _toDisplayString(item.zsEndTime), 1)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      class: "check_zs",
                      onClick: ($event: any) => (goZsInfo(item))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_43
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _hoisted_44
                ]))
          ], 64))
        }), 128))
      ])
    ])
  ]))
}
}

})